import { Box, Modal, Typography, IconButton, Fade } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    backdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.5) !important',
        backdropFilter: 'blur(4px)',
    },
    box: {
        maxHeight: '90vh',
        boxShadow: '0 24px 48px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '2em',
        backgroundColor: theme.palette.background.paper,
        outline: 'none',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme.palette.secondary.value,
        padding: theme.spacing(2),
    },
}));

const ModalOmniNew = ({
    open,
    handleClose,
    title,
    content,
    actions,
    customWidth,
    hideScroll,
    ForceBgWhite,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
    fadeDuration = 300,
    // Opt-in override for callers rendered above the default modal layer -
    // the active-call cards sit at 9999, so a modal opened from one would
    // otherwise appear behind the card that opened it.
    zIndex,
}, props) => {
    const classes = useStyles(props);

    const handleModalClose = (event, reason) => {
        if (disableBackdropClick && reason === 'backdropClick') return;
        if (disableEscapeKeyDown && reason === 'escapeKeyDown') return;
        handleClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleModalClose}
            aria-labelledby="modal-title-new"
            aria-describedby="modal-description-new"
            className={classes.modal}
            style={zIndex ? { zIndex } : undefined}
            BackdropProps={{ className: classes.backdrop }}
            closeAfterTransition
        >
            <Fade in={open} timeout={fadeDuration}>
                <Box
                    sx={{
                        width: customWidth || 400,
                        bgcolor: ForceBgWhite ? 'white' : 'background.paper',
                    }}
                    className={classes.box}
                >
                    <Box className={classes.header}>
                        <Typography variant="h5" id="modal-title-new" className="text-center flex-grow-1">
                            {title
                                ? title.toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
                                : ''}
                        </Typography>
                        <IconButton aria-label="close" onClick={() => handleClose && handleClose()} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <hr />

                    <Box
                        id="modal-description-new"
                        sx={{
                            overflowY: hideScroll || 'auto',
                            flexGrow: 1,
                            maxHeight: '80vh',
                        }}
                    >
                        {content}
                    </Box>

                    {actions && (
                        <Box m={2} display="flex" justifyContent="space-between">
                            {actions}
                        </Box>
                    )}
                </Box>
            </Fade>
        </Modal>
    );
};

export default ModalOmniNew;